/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Blocked_CancellationInputs */

const fr_membership_freeze_blocked_cancellation = /** @type {(inputs: Membership_Freeze_Blocked_CancellationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause indisponible : une résiliation est programmée.`)
};

/**

* @param {Membership_Freeze_Blocked_CancellationInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_blocked_cancellation = /** @type {((inputs?: Membership_Freeze_Blocked_CancellationInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Blocked_CancellationInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_blocked_cancellation(inputs)
});